export function StatTile({
  label,
  value,
  sub,
  valueClass = 'text-crt-lime',
}: {
  label: string
  value: string
  sub?: string
  valueClass?: string
}) {
  return (
    <div className="panel px-4 py-3">
      <div className="terminal-label">{label}</div>
      <div className={`mt-1 text-xl ${valueClass}`}>{value}</div>
      {sub ? <div className="mt-0.5 text-[11px] text-crt-dim">{sub}</div> : null}
    </div>
  )
}
